export const appSettings = {
  Google: {
    recaptchaSiteKey: import.meta.env.VITE_GOOGLE_RECAPTCHA_SITEKEYS,
  },
  AppFullName: import.meta.env.VITE_APP_FULL_NAME || 'OwnText Admin',
  CompanyName: import.meta.env.VITE_COMPANY_NAME || 'Z-Tech',
  RootUrl: import.meta.env.VITE_APP_ADMIN_URL,
  SupportEmail: import.meta.env.VITE_SUPPORT_EMAIL || 'manalo.rommel@gmail.com',

  AppUrl: {
    admin: import.meta.env.VITE_APP_ADMIN_URL,
    api: import.meta.env.VITE_APP_API_URL,
  },

  isDev: import.meta.env.MODE === 'development',
  nodeEnv: import.meta.env.MODE,
  userStorageKeys: {
    userId: 'owntext-login-userId',
    token: 'owntext-login-token',
  },
}
